import { render, staticRenderFns } from "./HomeUserNews.vue?vue&type=template&id=62fb03d6&"
import script from "./HomeUserNews.vue?vue&type=script&lang=js&"
export * from "./HomeUserNews.vue?vue&type=script&lang=js&"
import style0 from "./HomeUserNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports